import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { MaskConfig } from '../../../utility/mask-config';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TextAreaInputComponent } from '../text-area-input/text-area-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip'; 

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMaskDirective,
    MatIconModule,
    MatTooltipModule,
    TextAreaInputComponent,
  ],
  providers: [
    provideNgxMask(),
  ],
})
export class TextInputComponent extends BaseInputDirective implements OnInit, OnChanges {
  @Input() maskConfig: MaskConfig;
  @Input() autocomplete?: string;
  @Input() showCharacterCount: boolean = false;
  hasMask: boolean;
  @Output() richChange = new EventEmitter();
  @Output() richBlur = new EventEmitter();
  @Output() richKeyPress = new EventEmitter();

  
 
  



  ngOnInit() {
    super.ngOnInit();
    this.maskConfig = this.maskConfig || { mask: this.fgInfo.mask };
    this.hasMask = this.maskConfig.mask && this.maskConfig.mask.trim() !== '';
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    this.hasMask = this.fgInfo && this.fgInfo.mask && this.fgInfo.mask.trim() !== '';
  }
}
